import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
// import { useCookies } from 'react-cookie';
// import { InstagramEmbed } from 'react-social-media-embed';

const Section11 = () => {
  // const [cookies] = useCookies(['i18next']);
  const { t } = useTranslation();
  const [posts, setPosts] = useState([]);
  const [posts1, setPosts1] = useState([]);
  const [loading, setLoading] = useState(true);
  const [igLoading, setIgLoading] = useState(true);
  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      try {
        const url = process.env.REACT_APP_API_URL;

        const response = await axios.get(`${url}/institutions`);
        setPosts(response.data);
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.message,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  useEffect(() => {
    const fetchPosts1 = async () => {
      setIgLoading(true);
      try {
        const url = process.env.REACT_APP_API_URL;
        const response1 = await axios.get(`${url}/postsosmedfe`);
        setPosts1(response1.data);
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err.message,
        });
      } finally {
        setIgLoading(false);
      }
    };

    fetchPosts1();
  }, []);

  if (loading) return <p>Loading...</p>;

  return (
    <>
      {/* <section className="sm-section funfact-section-post"> */}
      <section className="mayor-section">
        <div className="container">
          <div className="sm-box">
            <div className="section-title-box text-center" data-aos="fade-up">
              <div className="section-tagline-b">{t("sosialMedia")}</div>
              <h2 className="section-title text-dark">{t("instagram")}</h2>
            </div>
          </div>
          <div className="row" style={{ rowGap: '20px', marginLeft: '-15px', marginRight: '-15px' }} data-aos="fade-down">
            {igLoading ? (
              Array.from({ length: 6 }).map((_, i) => (
                <div
                  className="col-lg-4 col-md-4 col-sm-6"
                  key={`ig-skeleton-${i}`}
                  style={{ padding: '0 15px' }}
                >
                  <div className="ig-card ig-card--skeleton" aria-hidden="true"></div>
                </div>
              ))
            ) : Array.isArray(posts1) && posts1.length > 0 ? (
              <>
                {posts1.slice(0, 6).map((item1, indexs) => (
                  <div
                    className="col-lg-4 col-md-4 col-sm-6"
                    key={item1.id || indexs}
                    style={{ padding: '0 15px' }}
                  >
                    <a
                      href={item1?.link_post}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="ig-card"
                      aria-label={item1?.caption || "Lihat postingan di Instagram"}
                      style={{ display: 'block', width: '100%', aspectRatio: '1/1', position: 'relative', overflow: 'hidden', borderRadius: '12px' }}
                    >
                      {item1?.media_type === 'video' && item1?.video_url ? (
                        <video
                          src={item1.video_url}
                          poster={item1.image_url}
                          autoPlay
                          muted
                          loop
                          playsInline
                          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                      ) : item1?.image_url ? (
                        <img
                          src={item1.image_url}
                          alt={item1?.caption || "Postingan Instagram KNEKS"}
                          loading="lazy"
                          decoding="async"
                          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                        />
                      ) : (
                        <span className="ig-card__fallback">
                          <i className="fa-brands fa-instagram"></i>
                          <span>{t("instagram")}</span>
                        </span>
                      )}
                      <span className="ig-card__badge">
                        <i className="fa-brands fa-instagram"></i>
                      </span>
                    </a>
                  </div>
                ))}
              </>
            ) : (
              <div
                className="col-lg-12 col-md-12"
                style={{ paddingBottom: "100px" }}
              >
                <p className="text-center text-danger">No posts available</p>
              </div>
            )}
          </div>

          <div className="row m-0" data-aos="fade-down" style={{ marginTop: '30px' }}>
            <div className="col-lg-4 col-md-4">
              <p className="text-center">
                <a
                  rel="noreferrer"
                  href="https://www.youtube.com/@komitenasionalekonomidanke2792"
                  target="_blank"
                >
                  <img
                    src="https://cms.kneks.go.id/assets/images/youtube.png"
                    alt="youtube"
                    width="80"
                  />{" "}
                  <br /> <b>@komitenasionalekonomidanke2792</b>
                </a>
              </p>
            </div>
            <div className="col-lg-4 col-md-4">
              <p className="text-center">
                <a
                  rel="noreferrer"
                  href="https://www.instagram.com/ekonomisyariah.official"
                  target="_blank"
                >
                  <img
                    src="https://cms.kneks.go.id/assets/images/instagram.png"
                    alt="instagram"
                    width="80"
                  />{" "}
                  <br />
                  <b>@ekonomisyariah.official</b>
                </a>
              </p>
            </div>
            <div className="col-lg-4 col-md-4">
              <p className="text-center">
                <a
                  rel="noreferrer"
                  href="https://www.instagram.com/kneks.id"
                  target="_blank"
                >
                  <img
                    src="https://cms.kneks.go.id/assets/images/instagram.png"
                    alt="instagram"
                    width="80"
                  />{" "}
                  <br /> <b>@kneks.go.id</b>
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "60px 0",
          overflow: "hidden",
        }}
      >
        <div className="sm-box">
          <div className="section-title-box text-center" data-aos="fade-up">
            <h2 className="section-title text-dark">{t("instansi")}</h2>
          </div>
        </div>
        <div className="container-fluid px-0">
          <style>
            {`
              .marquee-wrapper {
                overflow: hidden;
                white-space: nowrap;
                position: relative;
                width: 100%;
              }
              .marquee-container {
                display: flex;
                width: max-content;
                animation: marquee 40s linear infinite;
              }
              .marquee-container:hover {
                animation-play-state: paused;
              }
              .marquee-item {
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 0 40px;
                transition: transform 0.3s ease;
              }
              .marquee-item:hover {
                transform: scale(1.05);
              }
              .marquee-item img {
                max-width: 160px;
                max-height: 80px;
                object-fit: contain;
              }
              @keyframes marquee {
                0% { transform: translateX(0); }
                100% { transform: translateX(-50%); }
              }
            `}
          </style>
          <div className="marquee-wrapper">
            {posts && posts.length > 0 ? (
              <div className="marquee-container">
                {/* Menduplikasi array posts untuk menciptakan efek looping tanpa henti */}
                {[...posts, ...posts].map((item, index) => (
                  <div
                    className="marquee-item"
                    key={`marquee-${item?.id || index}`}
                  >
                    <a rel="noreferrer" href={item?.link} target="_blank">
                      <img
                        src={item?.logo}
                        className="img-fluid m-0"
                        alt={item?.title || "logo instansi"}
                      />
                    </a>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-center text-danger w-100">
                No posts available
              </p>
            )}
            {/* <div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://www.kemenkeu.go.id/`} target="_blank" className="component-service d-block ">
								<div className="service-image ">
									<img src="assets/image/kemenkeu.png" className="img-fluid " alt="kemenkeu" />
								</div>
							</a>
						</div> */}
            {/* <div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://www.ekon.go.id/`} target="_blank" className="component-service  d-block">
								<div className="service-image">
									<img src="assets/image/instansi2.png" className="img-fluid" alt="kementriang bidang perekonomian republik indonesia" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://www.kemenkopmk.go.id/`} target="_blank" className="component-service  d-block">
								<div className="service-image">
									<img src="assets/image/instansi32.png" className="img-fluid" alt="kemenko pmk" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://www.maritim.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi41.png" className="img-fluid" alt="maritim" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://www.kemenag.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi5.png" className="img-fluid" alt="kemenag" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://www.kemendag.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi7.png" className="img-fluid" alt="kemendag" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://bappenas.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi8.png" className="img-fluid" alt="bappenas" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://bumn.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi9.png" className="img-fluid" alt="bumn" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://kemenkopukm.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi10.png" className="img-fluid" alt="kemenkopukm" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://kemenparekraf.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi11.png" className="img-fluid" alt="kemenparekraf" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://mui.or.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi15.png" className="img-fluid" alt="mui" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-2 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://kadin.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi17.png" className="img-fluid" alt="kadin" />
								</div>
							</a>
						</div> */}

            {/* <div className="col-6 col-md-4 col-lg-3 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://bi.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi13.png" className="img-fluid" alt="bi" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-3 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://lps.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi14.png" className="img-fluid" alt="lps" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-3 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://www.kemenperin.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi6.png" className="img-fluid" alt="kemenperin" />
								</div>
							</a>
						</div>
						<div className="col-6 col-md-4 col-lg-3 pb-3" data-aos="fade-up">
							<a rel="noreferrer" href={`https://ojk.go.id/`} target="_blank" className="component-service d-block">
								<div className="service-image">
									<img src="assets/image/instansi12.png" className="img-fluid" alt="ojk" />
								</div>
							</a>
						</div> */}
          </div>
        </div>
      </section>

      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "60px 0",
          overflow: "hidden",
        }}
      >
        <div className="sm-box">
          <div className="section-title-box text-center" data-aos="fade-up">
            <h2 className="section-title text-dark">Mitra KNEKS</h2>
          </div>
        </div>

        {/* Pembungkus Logo */}
        <div
          className="container-fluid px-0"
          style={{
            display: "flex",            // Membuat elemen di dalamnya berjejer
            justifyContent: "center",   // Posisi di tengah
            alignItems: "center",       // Rata tengah secara vertikal
            flexWrap: "wrap",           // Otomatis turun baris jika layar kecil (HP)
            gap: "40px",                // Jarak antar logo
            marginTop: "30px"           // Jarak dari judul ke logo
          }}
        >
          <img
            src="/assets/image/logo_komdigi.png"
            className="img-fluid m-0"
            alt="logo komdigi"
            style={{
              height: "70px",           // Menyamakan tinggi logo
              width: "auto",            // Lebar menyesuaikan agar proporsional
              objectFit: "contain"      // Mencegah gambar gepeng
            }}
          />
          <img
            src="/assets/image/logo_bps.png"
            className="img-fluid m-0"
            alt="logo bps"
            style={{
              height: "70px",           // Tinggi disamakan dengan logo sebelumnya
              width: "auto",
              objectFit: "contain"
            }}
          />
        </div>
      </section>
    </>
  );
};
export default Section11;
